// extracted by mini-css-extract-plugin
export default {"no-results":"ErrorMessage_no-results__pII5+","title-wrapper":"ErrorMessage_title-wrapper__ly-uy"};